import { IOptions } from "../../types";

export const IDENTIFICADOR_OPTIONS: IOptions[] = [
  {
    name: 'CPF',
    value: 1
  },
  {
    name: 'CNPJ',
    value: 2
  },
  {
    name: 'Placa Cavalo',
    value: 3
  },
  {
    name: 'Placa Carreta',
    value: 4
  }
];
